var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSortControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52651 -1.54149e-07L-3.61348e-07 3.73333L2.64488 3.73333L2.64488 12L4.40814 12L4.40814 3.73333L7.05302 3.73333M7.34697 8.26667L10.8735 12L14.4 8.26667L11.7551 8.26667L11.7551 -5.13832e-07L9.99186 -4.36758e-07L9.99186 8.26667L7.34697 8.26667Z",
    fill: "#84858C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSortControl);
export default __webpack_public_path__ + "static/media/ic-sort-control.272b9b565f3672722c52e36e301c1cce.svg";
export { ForwardRef as ReactComponent };